import {
  ADDRESS_TYPE_SHIPPING,
  DISPLAY_DATE,
  FULFILMENT_DATE_CHANGED,
  LAST_FULFILLMENT_DATE_CHANGED,
  PICK_UP_TYPE
} from '@app/constants/commonConstants';
import { parse } from 'date-fns/parse';
import {
  PICKUP,
  DROPBOX,
  SHOP_ONLINE,
  DELIVERY,
  SUMMARY_AND_PAYMENT,
  UNITED_STATES
} from './constants';
import { PICKUP as PICK_UP } from '@app/components/pages/checkout/RequestByDate/constants';
import { format } from 'date-fns/format';
import { set } from 'date-fns/set';
import {
  fetchPriceAvailability,
  getCurrentOrderInfo
} from '@app/store/orders/actions';
import { loadPickupAndDeliveryPage } from '@app/store/checkout/actions';
import { getLocalStorage, replaceTokensInString } from '@app/utils';
import { removeLocalStorage } from '@app/utils/localStorageUtils';

export const getDefaultItemFromArray = (items, fallback = '') =>
  Array.isArray(items) ? items.find(i => i.default) || fallback : '';

export const getShippingAddresses = addressList =>
  Array.isArray(addressList)
    ? addressList?.filter(
        ({ addressType }) =>
          addressType?.toUpperCase() === ADDRESS_TYPE_SHIPPING
      )
    : [];

/**
 * @deprecated
 * see utils folder in checkout root
 */
export const getDefaultRequestByDate = (requestByDate = {}) => {
  const { value, format } = requestByDate;
  return !!value && !!format ? parse(value, format, new Date()) : null;
};

export const getSelectedFulfillmentType = (
  activeTab,
  selectedPickupLocation,
  pickupAddress
) => {
  let selected;
  const pickupAddressId =
    pickupAddress && pickupAddress.length > 0
      ? pickupAddress[0].addressId
      : null;
  if (activeTab === SHOP_ONLINE) {
    selected = SHOP_ONLINE;
  } else if (
    activeTab === PICKUP &&
    selectedPickupLocation &&
    selectedPickupLocation === pickupAddressId
  ) {
    selected = PICKUP;
  } else if (activeTab === PICKUP && !selectedPickupLocation && pickupAddress) {
    // if active tab i pickup but the selectedLocation is null
    // means the user change from delivery tab to píckup tab and
    // in the pickup tab the store is the only one option-NO Radio button
    selected = PICKUP;
  } else {
    selected = DROPBOX;
  }
  return selected;
};

export const includesTruck = method => {
  return method?.value?.toLowerCase()?.includes('truck');
};

const isGuestEnableShippment = ({
  isGuest,
  isGuestEnhancedShippingMethodsEnabled,
  PCCGuestDeliveryShipViaCode,
  showEstimatedDeliveryDates
}) =>
  isGuest &&
  ((!!PCCGuestDeliveryShipViaCode && !!showEstimatedDeliveryDates) ||
    !!isGuestEnhancedShippingMethodsEnabled);
export const getDefaultDeliveryMethods = ({
  isGuest,
  isGuestEnhancedShippingMethodsEnabled,
  isEligibleForTruck,
  methods = [],
  guestMethods = [],
  isStoreAvailabilityEnabled,
  isPCCDeliveryDropboxRBDByAvailability,
  PCCGuestDeliveryShipViaCode,
  showEstimatedDeliveryDates
}) => {
  let isGuestEnhancedEnabled = false;
  let defaultDeliveryMethods = methods;

  if (
    isGuestEnableShippment({
      isGuest,
      isGuestEnhancedShippingMethodsEnabled,
      PCCGuestDeliveryShipViaCode,
      showEstimatedDeliveryDates
    }) ||
    (isStoreAvailabilityEnabled &&
      isPCCDeliveryDropboxRBDByAvailability &&
      !isGuest)
  ) {
    if (isEligibleForTruck && isGuest) {
      // * Check if truck method exists
      const truckMethod = guestMethods.find(method => includesTruck(method));
      if (truckMethod) {
        defaultDeliveryMethods = [truckMethod];
        isGuestEnhancedEnabled = true;
      }
    } else {
      // * Checks if there are guest methods
      let daysShippingMethods = [];
      if (isGuest) {
        daysShippingMethods = guestMethods.filter(
          method => !includesTruck(method)
        );
      }
      if (daysShippingMethods.length >= 1) {
        defaultDeliveryMethods = daysShippingMethods;
        isGuestEnhancedEnabled = true;
      }
      if (!isGuest) {
        isGuestEnhancedEnabled = true;
      }
    }
  }

  return { defaultDeliveryMethods, isGuestEnhancedEnabled };
};

/* Function to retrieve the error for the continue to summary action
 * errorCode: comes from error in calculate and freight service
 * errorDesc: como from error in fulfillment or calculate and freight services
 * generalErrorMessage: comes from PUD main error but contains the general no-mapping message (like error network)
 */
export const getSystemFeedbackError = ({
  t,
  errorCode,
  errorDesc,
  generalErrorMessage
}) => {
  let title = '';
  let message = '';

  switch (errorCode) {
    case 'EW100':
    case 'UPC5151':
      title =
        errorDesc || t('PUD_WEIGHT_LIMIT_EXCEEDED_SYSTEM_FEEDBACK_ERROR1');
      message = t(
        'PUD_WEIGHT_LIMIT_EXCEEDED_CONTACT_DEALER__SYSTEM_FEEDBACK_ERROR2'
      );
      break;
    case 'EW102':
    case 'EW101':
      title = errorDesc || t('ORDER_PLACEMENT_UNAVAILABLE_HEADER');
      message = t('ORDER_PLACEMENT_UNAVAILABLE_BODY');
      break;
    case 'EWZOD':
      title = errorDesc || '';
      message = [
        t('DELIV_METHOD_ERR1'),
        t('DELIV_METHOD_ERR2'),
        t('DELIV_METHOD_ERR3')
      ];
      break;
    default:
      if (errorCode) {
        title = errorDesc || t('ORDER_PLACEMENT_UNAVAILABLE_HEADER');
        message = t('ORDER_PLACEMENT_UNAVAILABLE_BODY');
      } else if (generalErrorMessage) {
        title = t('UNKNOWN_ERROR_TITLE');
        message = t('UNKNOWN_ERROR_MESSAGE');
      }
      break;
  }

  return { title, message };
};

const getDefaultFulfillmentMappingErrorDesc = ({
  t,
  errorCode,
  isDelivery
}) => {
  let defaultErrorDesc = '';
  const isWeightError = ['EW100', 'UPC5151'].includes(errorCode);
  const isDeliveryError = errorCode === 'EWZOD';
  if (isDelivery) {
    defaultErrorDesc = isWeightError
      ? t('FREIGHT_CALL_WEIGHT_ERROR')
      : [t('DELIV_METHOD_ERR1'), t('DELIV_METHOD_ERR2')];
  } else {
    defaultErrorDesc = isWeightError
      ? t('PICK_UP_WEIGHT_EXCEEDS_ERROR')
      : [
          t('DELIV_METHOD_ERR1'),
          t('DELIV_METHOD_ERR2'),
          t('DELIV_METHOD_ERR3')
        ];
  }
  return {
    isWeightError,
    isDeliveryError,
    defaultErrorDesc: isWeightError || isDeliveryError ? defaultErrorDesc : ''
  };
};

/* we use this function for retrieve the error in the tax and freight service
 * errorCode:  comes from error in calculate and freight service
 * errorDesc: como from error in fulfillment or calculate and freight services
 */
export const getWeightLimitError = ({
  t,
  errorCode,
  errorDesc,
  fulfillmentType
}) => {
  const isDelivery = fulfillmentType === SHOP_ONLINE;
  const { defaultErrorDesc, isWeightError, isDeliveryError } =
    getDefaultFulfillmentMappingErrorDesc({
      t,
      isDelivery,
      errorCode
    });
  let title = '';
  let message = errorDesc || defaultErrorDesc;

  if (errorCode === 'EW102') {
    title = errorDesc || t('ORDER_PLACEMENT_UNAVAILABLE_HEADER');
    message = t('ORDER_PLACEMENT_UNAVAILABLE_BODY');
  } else if ((!isWeightError || !isDeliveryError) && errorCode) {
    message = errorDesc || t('ORDER_PLACEMENT_UNAVAILABLE_BODY');
  }

  return { title, message };
};

export const getAvailabilityFormattedDate = (date, rbdFormat) => {
  if (!isNaN(new Date(date))) {
    return set(new Date(date), {
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0
    });
  }
  return set(parse(date, rbdFormat, new Date()), {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  });
};
export const getAvailableByDate = (
  fulfillmentType,
  estimatedPickUpAvailableDate,
  estimatedDropBoxAvailableDate,
  estimatedDeliveryAvailableDate,
  rbdFormat
) => {
  if (
    (fulfillmentType === PICKUP || fulfillmentType === PICK_UP) &&
    estimatedPickUpAvailableDate
  ) {
    return getAvailabilityFormattedDate(
      estimatedPickUpAvailableDate,
      rbdFormat
    );
  } else if (fulfillmentType === DROPBOX && estimatedDropBoxAvailableDate) {
    return getAvailabilityFormattedDate(
      estimatedDropBoxAvailableDate,
      rbdFormat
    );
  } else if (
    (fulfillmentType === SHOP_ONLINE || fulfillmentType === DELIVERY) &&
    estimatedDeliveryAvailableDate
  ) {
    return getAvailabilityFormattedDate(
      estimatedDeliveryAvailableDate,
      rbdFormat
    );
  }
};

export const calculateRemainingTime = cutoffTimeGMT => {
  if (!cutoffTimeGMT || isNaN(new Date(cutoffTimeGMT).getTime())) {
    return {
      total: 0,
      hours: 0,
      minutes: 0
    };
  }
  const currentTime = new Date().getTime();
  const cutoffTimeMillis = new Date(cutoffTimeGMT).getTime() + 6e4; // updated to include additional one minute
  const totalMilliseconds =
    cutoffTimeMillis > currentTime ? cutoffTimeMillis - currentTime : 0;
  const remainingHours = Math.floor(totalMilliseconds / 36e5);
  //If the remaining hours is less than 12 then we won't calculate the minutes
  const remainingMinutes =
    remainingHours < 12 ? Math.floor((totalMilliseconds % 36e5) / 6e4) : 0;
  return {
    total: cutoffTimeMillis,
    hours: remainingHours,
    minutes: remainingMinutes
  };
};
const getPriceAndAvailabilityAndXorder = ({
  dispatch,
  fieldValueObj,
  fulfillment,
  showToasterFulFillment,
  availabilityMessage,
  pageType
}) => {
  dispatch(
    fetchPriceAvailability({ invokeXorder: false, skipAddressValidation: true })
  ).then(() => {
    dispatch(
      getCurrentOrderInfo({
        fieldValueObj,
        showToasterFulFillment:
          fulfillment === PICKUP || fulfillment === PICK_UP_TYPE
            ? showToasterFulFillment
            : null,
        cartItems: false,
        isCallingFromCounter: true,
        availabilityMessage,
        pageType
      })
    );
  });
};
export const getPickupAndDeliveryPage = ({
  fulfillment,
  dispatch,
  availabilityMessage,
  fieldValueObj,
  showToasterFulFillment,
  pageType,
  isGuestAndDeliveryFullfilment,
  taxAndFreightTrigger,
  taxAndFreight,
  isGuestEnhancedEnabled
}) => {
  if (isGuestAndDeliveryFullfilment) {
    if (
      (isGuestEnhancedEnabled || pageType === SUMMARY_AND_PAYMENT) &&
      taxAndFreight?.length
    ) {
      taxAndFreightTrigger(
        fieldValueObj?.fieldValue,
        showToasterFulFillment,
        fieldValueObj,
        availabilityMessage,
        true
      );
    } else {
      dispatch(
        loadPickupAndDeliveryPage({
          isDeliveryEnabled: true,
          isPickupEnabled: false,
          isDropboxEnabled: false,
          isCallingFromCounter: true,
          fieldValueObj,
          showToasterFulFillment,
          pageType,
          isGuestAndDeliveryFullfilment
        })
      );
    }
    getPriceAndAvailabilityAndXorder({
      dispatch,
      fieldValueObj,
      fulfillment,
      showToasterFulFillment,
      availabilityMessage,
      pageType
    });
  } else {
    if (
      fulfillment === PICKUP ||
      fulfillment === PICK_UP_TYPE ||
      pageType === SUMMARY_AND_PAYMENT
    ) {
      getPriceAndAvailabilityAndXorder({
        dispatch,
        fieldValueObj,
        fulfillment,
        showToasterFulFillment,
        availabilityMessage,
        pageType
      });
    }
    dispatch(
      loadPickupAndDeliveryPage({
        isDeliveryEnabled: fulfillment === DELIVERY,
        isPickupEnabled: fulfillment === PICKUP || fulfillment === PICK_UP_TYPE,
        isDropboxEnabled: fulfillment === DROPBOX,
        availabilityMessage: availabilityMessage,
        isCallingFromCounter: true,
        fieldValueObj,
        showToasterFulFillment,
        pageType
      })
    );
  }
};
const getToasterFlag = ({
  fulfillmentType,
  fulfillment,
  shipCode,
  selectedShipmentCode,
  isAllCutOffTimeSame,
  cutOFFDateTimeEmptyList,
  prevAvailabilityMessage,
  currentAvailabilityMessage
}) => {
  if (
    prevAvailabilityMessage === currentAvailabilityMessage &&
    !!currentAvailabilityMessage
  ) {
    return;
  }
  if (fulfillmentType === DELIVERY) {
    if (cutOFFDateTimeEmptyList.some(code => code === selectedShipmentCode)) {
      return;
    }
    if (shipCode === selectedShipmentCode || isAllCutOffTimeSame) {
      return true;
    }
  }
  return fulfillmentType === fulfillment;
};
export const clearlocalStoreFullfillment = ({
  fulfillment,
  availableByDate,
  formRequestValue,
  shipCode,
  selectedShipmentCode,
  isAllCutOffTimeSame,
  cutOFFDateTimeEmptyList,
  prevAvailabilityMessage,
  currentAvailabilityMessage
}) => {
  const lastDateModifiedFillment = getLocalStorage(
    LAST_FULFILLMENT_DATE_CHANGED
  );
  const fulFilentDateChanged = getLocalStorage(FULFILMENT_DATE_CHANGED);
  let fulfillmentType = '';
  if (!!fulFilentDateChanged) {
    fulfillmentType = JSON.parse(fulFilentDateChanged)?.fulfillmentType;
  } else if (!!lastDateModifiedFillment) {
    fulfillmentType = lastDateModifiedFillment;
  }

  if (
    getToasterFlag({
      fulfillmentType,
      fulfillment,
      shipCode,
      selectedShipmentCode,
      isAllCutOffTimeSame,
      cutOFFDateTimeEmptyList,
      prevAvailabilityMessage,
      currentAvailabilityMessage
    }) &&
    format(new Date(availableByDate), DISPLAY_DATE) >
      format(new Date(formRequestValue), DISPLAY_DATE)
  ) {
    removeLocalStorage(FULFILMENT_DATE_CHANGED);
    removeLocalStorage(LAST_FULFILLMENT_DATE_CHANGED);
  }
};

export const showDateUpdatedToaster = ({
  fulfillmentType,
  fulfillment,
  shipCode,
  toastCtx,
  t,
  isRBDFieldUpdate,
  selectedShipmentCode,
  isAllCutOffTimeSame,
  cutOFFDateTimeEmptyList,
  prevAvailabilityMessage,
  currentAvailabilityMessage,
  isGuestDeliveryShipViaCode,
  isGuestEnhancedEnabled,
  showEstimatedDeliveryDates,
  taxAndFreight,
  isGuestAndDeliveryFullfilment,
  pccHideEstDateForNonAvailableItems
}) => {
  const { toasts } = toastCtx;
  const tosterDateMsg = {
    pickUp: 'PICKUP_DATE_UPDATED',
    pickup: 'PICKUP_DATE_UPDATED', // Handnling different response from API (fulfillment value) for SummaryAndPayment Page for guest user
    dropBox: 'DROPBOX_DATE_UPDATED',
    delivery: 'DELIVERY_DATE_UPDATED'
  };
  const tosterRBDDateMsg = {
    pickUp: 'PICKUP_RBD_DATE_UPDATED',
    pickup: 'PICKUP_RBD_DATE_UPDATED', // Handnling different response from API (fulfillment value) for SummaryAndPayment Page for guest user
    dropBox: 'DROPBOX_RBD_DATE_UPDATED',
    delivery: 'DELIVERY_RBD_DATE_UPDATED'
  };
  const isAlreadyRBDonlyMsgToaster = toasts.some(
    sme => sme.message === t('SUMMARY_RBD_UPDATED')
  );
  const isAlreadyRBDateMsgToaser = toasts.some(
    sme => sme.message === t(`${tosterRBDDateMsg[fulfillment]}`)
  );
  const isAlreadyMsgToaster = toasts.find(
    fnd => fnd.message === t(`${tosterDateMsg[fulfillment]}`)
  );
  const hideEstimatedDate =
    pccHideEstDateForNonAvailableItems && !currentAvailabilityMessage;
  if (
    getToasterFlag({
      fulfillmentType,
      fulfillment,
      shipCode,
      selectedShipmentCode,
      isAllCutOffTimeSame,
      cutOFFDateTimeEmptyList,
      currentAvailabilityMessage,
      prevAvailabilityMessage
    })
  ) {
    if (!isRBDFieldUpdate) {
      if (
        isGuestAndDeliveryFullfilment &&
        isGuestDeliveryShipViaCode &&
        !taxAndFreight.length
      ) {
        return;
      }
      if (!isAlreadyMsgToaster && !!currentAvailabilityMessage) {
        isAlreadyRBDateMsgToaser && toastCtx.destroyAllToasts();
        toastCtx.createWarningToast(
          t(`${tosterDateMsg[fulfillment]}`),
          Infinity
        );
      }
    } else {
      if (
        (isGuestAndDeliveryFullfilment &&
          isGuestDeliveryShipViaCode &&
          !taxAndFreight.length) ||
        hideEstimatedDate
      ) {
        if (!isAlreadyRBDonlyMsgToaster) {
          toastCtx.destroyAllToasts();
          toastCtx.createWarningToast(t('SUMMARY_RBD_UPDATED'), Infinity);
        }
      } else if (!isAlreadyRBDateMsgToaser) {
        toastCtx.destroyAllToasts();
        toastCtx.createWarningToast(
          t(`${tosterRBDDateMsg[fulfillment]}`),
          Infinity
        );
      }
    }
  }
};

export const getCuttOffDetails = methods => {
  if (!methods) {
    return {
      filterMethods: [],
      emptyCutOffTimeListCode: [],
      isAllCutOffTimeSame: false
    };
  }
  const filterMethods = methods?.filter(
    flt => flt.estimatedDeliveryDate?.cutOffDateTime !== ''
  );
  const emptyCutOffTimeListCode = methods
    ?.filter(flt => flt.estimatedDeliveryDate?.cutOffDateTime === '')
    ?.map(itm => itm.code);
  const isAllCutOffTimeSame = filterMethods?.every(
    val =>
      val.estimatedDeliveryDate?.cutOffDateTime ===
      filterMethods[0]?.estimatedDeliveryDate?.cutOffDateTime
  );
  return {
    filterMethods,
    emptyCutOffTimeListCode,
    isAllCutOffTimeSame
  };
};

// If cutoff above 12 hours we render the hours
// If cutoff hours are 0 and minutes above 0 we render the minutes
// If cutoff hours less than 12 but not 0 and minutes are 0 we render the hours
// If cutoff hours less than 12 but not 0 and minutes above 0 we render hours and minutes
const getHoursMinutesFormat = (hours, minutes) => {
  if (hours >= 12 || (hours > 0 && hours <= 12 && minutes === 0)) {
    return 'EARLIEST_AVAILABLE_CUTOFF_HOURS';
  } else if ((hours === 0 && minutes > 0) || (hours === 0 && minutes === 0)) {
    return 'EARLIEST_AVAILABLE_CUTOFF_MINUTES';
  } else {
    return 'EARLIEST_AVAILABLE_CUTOFF';
  }
};

export const getOrderWithinFormat = (
  orderByTime,
  hours,
  minutes,
  t,
  isGuestDeliveryShipViaCode,
  isGuestAndDeliveryFullfilment
) => {
  // Threat negative values as zeros
  hours = Math.max(0, hours);
  minutes = Math.max(0, minutes);

  // If the feature flag isGuestDeliveryShipViaCode is false OR If there's more that 72 hours for cutoff we will use default api text
  if (
    hours >= 72 ||
    (!isGuestDeliveryShipViaCode && isGuestAndDeliveryFullfilment)
  ) {
    return orderByTime;
  }

  // If less than 72 hours we use "Order within" format
  const cutOffTranslationKey = getHoursMinutesFormat(hours, minutes);
  return replaceTokensInString(t(cutOffTranslationKey), hours, minutes);
};

export const getEstimatedateArrayObject = ({
  isGuest,
  isGuestEnhancedShippingMethodsEnabled,
  estimatedDate,
  taxAndFreightValue,
  taxAndFreight,
  methods,
  objFlag,
  estimateDateIndicator,
  isGuestDeliveryShipViaCode
}) => {
  if (
    !isGuestDeliveryShipViaCode &&
    !!taxAndFreight.length &&
    !!taxAndFreightValue?.estimatedDeliveryDate
  ) {
    if (objFlag) {
      taxAndFreightValue.estimatedDeliveryDate.cutOffDateTime = '';
    } else {
      taxAndFreight?.map(
        itm => (itm.estimatedDeliveryDate.cutOffDateTime = '')
      );
    }
  }
  if (
    isGuest &&
    !!taxAndFreight.length &&
    ((isGuestDeliveryShipViaCode && estimateDateIndicator) ||
      isGuestEnhancedShippingMethodsEnabled)
  ) {
    return objFlag ? taxAndFreightValue?.estimatedDeliveryDate : taxAndFreight;
  }
  return objFlag ? estimatedDate : methods;
};

export const getDeliverymethodsWithCutOff = (
  isGuest,
  PCCGuestDeliveryShipViaCode,
  showEstimatedDeliveryDates,
  isGuestEnhancedShippingMethodsEnabled,
  methods,
  guestMethods,
  defaultDeliveryMethods
) => {
  if (
    isGuest &&
    PCCGuestDeliveryShipViaCode &&
    !showEstimatedDeliveryDates &&
    !isGuestEnhancedShippingMethodsEnabled &&
    guestMethods?.[0]?.estimatedDeliveryDate
  ) {
    return methods.map(itm => ({
      ...itm,
      estimatedDeliveryDate: { ...guestMethods?.[0]?.estimatedDeliveryDate }
    }));
  }
  return defaultDeliveryMethods;
};
export const getHideEstimate = (
  isGuest,
  isGuestEnhancedShippingMethodsEnabled,
  estimateDateIndicator,
  isGuestDeliveryShipViaCode,
  hideEstimatedDeliveryDate,
  isHideEstDateForNonAvailableItems
) => {
  if (
    isGuest &&
    ((((isGuestDeliveryShipViaCode && !estimateDateIndicator) ||
      !isGuestDeliveryShipViaCode) &&
      !isGuestEnhancedShippingMethodsEnabled) ||
      (isHideEstDateForNonAvailableItems && hideEstimatedDeliveryDate))
  ) {
    return true;
  }
  return (
    !isGuest &&
    (isHideEstDateForNonAvailableItems ? hideEstimatedDeliveryDate : false)
  );
};

export const shouldShowViewMap = (
  pickupAddress,
  dropBoxData,
  isMapHiddenForTractafric
) => {
  if (isMapHiddenForTractafric) {
    return false;
  }

  const hasPickupCoords =
    !!pickupAddress?.latitude && !!pickupAddress?.longitude;
  const hasDropboxCoords = dropBoxData?.address?.some(
    address => !!address.latitude && !!address.longitude
  );

  return hasPickupCoords || hasDropboxCoords;
};

export const isAllContactDealerItems = orderItems => {
  return orderItems?.every(itm =>
    itm?.availability?.every(innerItm => innerItm?.showContactDealerPopUp)
  );
};
export const guestUserContactDealer = (
  taxAndFreight,
  hideEstDateforContactDealerPart
) => {
  return !!taxAndFreight.length
    ? taxAndFreight.every(
        item => item?.estimatedDeliveryDate?.availabilityMessage === null
      )
    : hideEstDateforContactDealerPart;
};

export const getDisclaimerMessage = ({
  t,
  taxDisclaimerFeatureFlag,
  taxDisclaimerMessageFooter,
  taxExcludedDisclaimerMessageFooter,
  showGST,
  includeGST,
  isCheckFreightSuccessful
}) => {
  if (isCheckFreightSuccessful) {
    return taxExcludedDisclaimerMessageFooter;
  }

  if (taxDisclaimerFeatureFlag) {
    return taxDisclaimerMessageFooter;
  }

  if (showGST) {
    return includeGST
      ? t('CAT_GST_DISCLAIMER_MSG_SHOPPINGCART')
      : t('CAT_AUSITEM_EXCLUDES_GST_TAX_FOOTER_NO_ASTERISK');
  }
};

export const consentFormManipulation = (
  selectedCountry,
  formType,
  consentValue
) => {
  // conditions can uncommented once proper AC'S were refined.

  // Condition 1
  // if (
  //   selectedCountry === UNITED_STATES &&
  //   (formType === 'marketing' || formType === 'non-marketing') &&
  //   consentValue >= 0 &&
  //   consentValue <= 4
  // ) {
  //   return false; // Do not show the entire form
  // }
  // Condition 2
  // if (
  //   selectedCountry !== UNITED_STATES &&
  //   formType === 'marketing' &&
  //   consentValue >= 1 &&
  //   consentValue <= 4
  // ) {
  //   return false; // Do not show the entire form
  // }
  // Condition 3
  if (
    selectedCountry !== UNITED_STATES &&
    formType === 'non-marketing' &&
    consentValue === 0
  ) {
    return true; // Show only 1 div content
  }
  return false; // Default is to hide the form
};

export const marketingConsenStatus = (
  selectedCountry,
  formType,
  consentValue
) => {
  const form = document.getElementById('MarketingConsent');
  if (!form) {
    console.error('form not present', form);
    return;
  }

  const optOutForm = form.querySelector('.consentDetails');
  const SbtButton = form.querySelector('.SbtButton');
  const marginTop30 = form.querySelector('.row');
  const consentFormTitle = document.querySelector('#MarketingConsent h2');
  const countryLabel = document.querySelector('label[for="contry"]');
  const SbAsk = document.querySelector('label[for="SbAsk"]');
  const breakTags = document.querySelectorAll('#MarketingConsent br');
  const countrySelect = document.getElementById('contry');
  const sbAskSelect = document.getElementById('SbAsk');

  if (consentFormTitle) {
    consentFormTitle.style.display = 'none';
  }
  if (countryLabel) {
    countryLabel.style.display = 'none';
  }
  if (SbAsk) {
    SbAsk.style.display = 'none';
  }
  breakTags.forEach(tag => tag.remove());
  if (countrySelect) {
    countrySelect.style.display = 'none';
  }
  if (sbAskSelect) {
    sbAskSelect.style.display = 'none';
  }

  if (consentFormManipulation(selectedCountry, formType, consentValue)) {
    form.style.display = 'block';

    if (
      selectedCountry !== UNITED_STATES &&
      formType === 'non-marketing' &&
      consentValue === 0
    ) {
      optOutForm.querySelector('#optOutAuthorizationForm').style.display =
        'none';
      optOutForm.querySelector('#FullAuthorizationForm').style.display = 'none';
      optOutForm.querySelector('#hiddenBlocks').style.display = 'none';
      SbtButton.style.display = 'none';
      marginTop30.style.display = 'none';
    }
  } else {
    form.style.display = 'none';
  }
};
